import { render, staticRenderFns } from "./OurCasesBlock.vue?vue&type=template&id=41320647&scoped=true"
import script from "./OurCasesBlock.vue?vue&type=script&lang=js"
export * from "./OurCasesBlock.vue?vue&type=script&lang=js"
import style0 from "./OurCasesBlock.vue?vue&type=style&index=0&id=41320647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41320647",
  null
  
)

export default component.exports